<template>
    <div>
        <div v-show="showDetail" class="yls-product-bottom">
            <div class="yls-product-bottom-detail">
                <div v-for="item in bottomList" :key="item.key">
                    <div class="yls-product-bottom-title">{{ item.title }}</div>
                    <div
                        class="yls-product-bottom-item"
                        v-for="val in item.items"
                        :key="val.key"
                        @click="handleGo(val.link)"
                    >
                        {{ val.value }}
                    </div>
                </div>
            </div>
            <div class="yls-product-bottom-contact">
                <div class="contact-tips">生涯发展 职业规划 智慧就业</div>
                <div class="contact-us">
                    联系我们：<a
                        class="yls-product-bottom-phone"
                        href="javascript: void 0"
                        >186-1161-8299</a
                    >
                    /
                    <a
                        class="yls-product-bottom-phone"
                        href="javascript: void 0"
                        >susu@yolosho.com</a
                    >
                </div>
                <div class="contact-way-img">
                    <div
                        v-for="(val, index) in contactList"
                        :key="index"
                        class="yls-product-bottom-img"
                    >
                        <img :src="val" :alt="val" />
                    </div>
                </div>
            </div>
            <div class="yls-product-bottom-copyright">
                <div class="copyright-left">
                    <div class="copyright-left-item">
                        北京宇乐树科技有限公司
                    </div>
                    <div class="copyright-left-item">宇乐树生涯</div>
                    <div class="copyright-left-item">
                        YOLOSHO&copy;Copyright 2023
                    </div>
                </div>
                <div class="copyright-right">
                    <a href="https://beian.miit.gov.cn/" target="_blank">京公网安备11011302007009号丨京ICP备2021010917号-2</a>
                </div>
            </div>
        </div>
        <div v-show="!showDetail" class="yls-product-bottom-min">
            <div class="yls-product-bottom-min-detail">
                <span>产品</span><i class="el-icon-plus"></i>
            </div>
            <div class="yls-product-bottom-min-detail">
                <span>解决方案</span><i class="el-icon-arrow-right"></i>
            </div>
            <div class="yls-product-bottom-min-detail">
                <span>课程</span><i class="el-icon-plus"></i>
            </div>
            <div class="yls-product-bottom-min-detail">
                <span>客户案例</span><i class="el-icon-arrow-right"></i>
            </div>
            <div class="yls-product-bottom-min-detail">
                <span>了解宇乐树</span><i class="el-icon-plus"></i>
            </div>
            <div class="yls-product-bottom-contact">
                <div class="contact-tips">生涯发展 职业规划 智慧就业</div>
                <div class="contact-us">
                    联系我们：<a
                        class="yls-product-bottom-phone"
                        href="javascript: void 0"
                        >186-1161-8299</a
                    >
                    /
                    <a
                        class="yls-product-bottom-phone"
                        href="javascript: void 0"
                        >susu@yolosho.com</a
                    >
                </div>
            </div>
            <div class="contact-way-img">
                <img
                    class="yls-product-bottom-img"
                    v-for="(val, index) in contactList"
                    :key="index"
                    :src="val"
                    :alt="val"
                />
            </div>
            <div class="yls-product-bottom-copyright">
                <div class="copyright-left">
                    <div class="copyright-left-item">
                        北京宇乐树科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;宇乐树生涯
                    </div>
                    <div class="copyright-left-item">
                        YOLOSHO&copy;Copyright 2023
                    </div>
                </div>
                <div class="copyright-right">
                    <a href="https://beian.miit.gov.cn/" target="_blank">京公网安备11011302007009号丨京ICP备2021010917号-2</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tools from "@/utils/tools";
const { getRandomKey } = tools;
export default {
    name: "customFooter",
    data() {
        return {
            showDetail: true,
            bottomList: [
                {
                    key: getRandomKey(),
                    title: "产品",
                    items: [
                        { key: getRandomKey(), value: "AI就业平台", link: "" },
                        {
                            key: getRandomKey(),
                            value: "生涯发展工具系列",
                            link: "/careerDevelopUtilsPro",
                        },
                        {
                            key: getRandomKey(),
                            value: "AI面试亭",
                            link: "/aiInterviewPro",
                        },
                        {
                            key: getRandomKey(),
                            value: "AI面试一体机",
                            link: "/aiInterviewAllPro",
                        },
                        {
                            key: getRandomKey(),
                            value: "AI生涯互动台",
                            link: "/aiCareerPro",
                        },
                        {
                            key: getRandomKey(),
                            value: "VR职业体验一体机",
                            linkk: "/vrCareerExpPro",
                        },
                    ],
                },
                {
                    key: getRandomKey(),
                    title: "解决方案",
                    items: [
                        { key: getRandomKey(), value: "职业生涯特色咨询室" },
                        { key: getRandomKey(), value: "生涯团辅空间" },
                        {
                            key: getRandomKey(),
                            value: "职业规划与智慧就业中心",
                        },
                        { key: getRandomKey(), value: "学生发展指导中心" },
                        {
                            key: getRandomKey(),
                            value: "一站式学生职业规划与就业服务中心",
                        },
                    ],
                },
                {
                    key: getRandomKey(),
                    title: "课程",
                    items: [
                        { key: getRandomKey(), value: "师资认证" },
                        { key: getRandomKey(), value: "宇乐星辰训练" },
                        { key: getRandomKey(), value: "职规大赛" },
                        { key: getRandomKey(), value: "K12课程服务" },
                    ],
                },
                {
                    key: getRandomKey(),
                    title: "客户案例",
                    items: [{ key: getRandomKey(), value: "客户案例" }],
                },
                {
                    key: getRandomKey(),
                    title: "了解宇乐树",
                    items: [
                        { key: getRandomKey(), value: "了解宇乐树" },
                        { key: getRandomKey(), value: "宇乐树生涯科技研究所" },
                        { key: getRandomKey(), value: "合作伙伴计划" },
                        { key: getRandomKey(), value: "加入我们" },
                    ],
                },
            ],
            contactList: [
                require("@/assets/images/aiInterviewAllPro/wechat.png"),
                require("@/assets/images/aiInterviewAllPro/tiktok.png"),
                require("@/assets/images/aiInterviewAllPro/Vector.png"),
            ],
        };
    },
    mounted() {
        this.watchViewResize();
    },
    methods: {
        handleGo(url) {
            if (url) {
                window.scrollTo({ top: 0, behavior: "smooth" });
                this.$router.replace(url);
            }
        },
        // 监听视口大小变化
        watchViewResize() {
            const observer = new ResizeObserver((ob = []) => {
                const { clientWidth } = (ob[0] || {}).target;
                if (clientWidth < 900) {
                    this.showDetail && (this.showDetail = false);
                    return;
                }
                !this.showDetail && (this.showDetail = true);
            });
            observer.observe(document.body);
        },
    },
};
</script>

<style scoped lang="less">
.yls-product-bottom {
    padding: 80px 6% 20px 6%;
    background-color: #62a243;
    color: #fff;
    .yls-product-bottom-detail,
    .yls-product-bottom-contact {
        padding-bottom: 20px;
        border-bottom: 2px solid rgba(255, 255, 255, 0.2);
    }
    .yls-product-bottom-detail {
        display: grid;
        padding-bottom: 20px;
        grid-template-columns: repeat(5, 1fr);
        border-bottom: 2px solid rgba(255, 255, 255, 0.2);
        .yls-product-bottom-title {
            font-weight: 600;
            margin-bottom: 20px;
        }
        .yls-product-bottom-item {
            padding: 6px 0;
            opacity: 0.8;
            cursor: pointer;
        }
    }
    .yls-product-bottom-contact {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 20px;
        .contact-tips,
        .contact-us {
            font-weight: 600;
        }
        .contact-us {
            .yls-product-bottom-phone {
                color: #fff;
            }
        }
        .contact-way-img {
            min-width: 160px;
            display: flex;
            align-content: center;
            justify-content: space-between;
            .yls-product-bottom-img {
                display: flex;
                align-content: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                padding: 10px;
                border-radius: 50%;
                background-color: #fff;
            }
        }
    }
    .yls-product-bottom-copyright {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 40px 0;
        font-size: 12px;
        opacity: 0.8;
        .copyright-left {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .copyright-right > a{
            color: #eee;
            text-decoration: none;
        }
    }
}
.yls-product-bottom-min {
    padding: 80px 6% 20px 6%;
    background-color: #62a243;
    color: #fff;
    .yls-product-bottom-min-detail {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 600;
        margin-bottom: 40px;
        .el-icon-plus,
        .el-icon-arrow-right {
            font-weight: 800;
            font-size: 18px;
        }
    }
    .yls-product-bottom-contact {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 40px 0;
        border-top: 2px solid rgba(255, 255, 255, 0.2);
        border-bottom: 2px solid rgba(255, 255, 255, 0.2);
        .yls-product-bottom-phone {
            color: #fff;
        }
    }
    .contact-way-img {
        min-width: 160px;
        padding: 40px 0 20px;
        .yls-product-bottom-img {
            margin-right: 40px;
            width: 20px;
            height: 20px;
            padding: 10px;
            border-radius: 50%;
            background-color: #fff;
        }
    }
    .yls-product-bottom-copyright {
        padding: 40px 0;
        font-size: 14px;
        opacity: 0.8;
        .copyright-left {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
            .copyright-left-item {
                margin-right: 40px;
            }
        }
        .copyright-right > a{
            color: #eee;
            text-decoration: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/customFooter.vue